export class FilterPosition {
    positionNum!: string;
    description!: string;
}